import { isEmpty } from "lodash-es";
import { type CountryCodeValue } from "@/main";
import { PickerBtn } from "@/comps/PickerBtn";
import { openRegionCascaderModal } from "./openRegionCascaderModal";
import { type RHFField } from "@/common/RHFWrapper";
import { type AddressItem } from "$/utils/fetchGeoData";

interface RegionPickerProps extends RHFField {
  value?: AddressItem[];
  onChange?: (value: AddressItem[]) => void;
  residenceCountry: CountryCodeValue;
  code: string;
  label: string;
  classNames?: {
    wrapper?: string;
    content?: string;
    label?: string;
    value?: string;
    icon?: string;
  };
}

export const RegionPicker = ({
  value,
  label,
  onChange,
  residenceCountry,
  code,
  ...props
}: RegionPickerProps) => {
  return (
    <PickerBtn
      key={residenceCountry}
      label={label}
      value={!isEmpty(value) ? value?.map((v) => v.name).join("") : undefined}
      onClick={async () => {
        const { geoInfos } = await openRegionCascaderModal({
          residenceCountry,
          code,
          value,
          title: label,
        });
        onChange?.(geoInfos);
      }}
      {...props}
    />
  );
};
